import React from 'react';

const BlankUserPhoto = ({ color }) => {
  return (
    <svg
      style={{ borderRadius: '50%' }}
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      width="82"
      height="82"
      viewBox="0 0 82 82"
      role="img"
      aria-label="Default avatar photo. To add a photo, click the `Add Profile Photo` button"
    >
      <defs>
        <clipPath id="a">
          <circle
            className="a"
            cx="41"
            cy="41"
            r="41"
            transform="translate(48 121)"
          />
        </clipPath>
      </defs>
      <g className="b" transform="translate(-48 -121)">
        <title>Blank User Profile Photo</title>
        <g transform="translate(47.999 121.002)">
          <path
            className="c"
            d="M73.061,76.154c-1.119,1.708-3.607,1.906-4.608,1.906H5.153c-1,0-3.489-.2-4.608-1.906s-.346-4.247.927-7.221a61.9,61.9,0,0,1,8.192-14.1A54.092,54.092,0,0,1,22.582,43.967a2.642,2.642,0,0,1,1.472-.434,2.819,2.819,0,0,1,1.472.559A21.294,21.294,0,0,0,36.8,47.942a21.294,21.294,0,0,0,11.313-3.85,2.819,2.819,0,0,1,1.472-.559,2.642,2.642,0,0,1,1.472.434A54.092,54.092,0,0,1,63.941,54.838a61.894,61.894,0,0,1,8.192,14.1C73.406,71.907,74.187,74.432,73.061,76.154Z"
            transform="translate(5 5.937)"
          />
          <path
            className="c"
            d="M39.337,0C49.016.125,54.588,5.469,55.53,15.413A29.266,29.266,0,0,1,54.75,27c-2.429,7.986-8.833,13.249-15.862,13.116-7.154-.155-13.455-5.675-15.589-13.7a28.846,28.846,0,0,1,.14-14.868C25.485,3.68,30.814-.1,39.337,0Z"
            transform="translate(2.708 10.393)"
          />
        </g>
      </g>
    </svg>
  );
};

export default BlankUserPhoto;
